import type { FC } from "react";

import { ImageLink as ImageLinkUi } from "@jti/ui/eva-components/ImageLink/ImageLink";

import type { imageLinkInputs } from "./ImageLink.builder";

export type ImageLinkProps = BuilderComponentProps<typeof imageLinkInputs>;

export const ImageLink: FC<ImageLinkProps> = (props) => {
  return <ImageLinkUi {...props} />;
};

export default ImageLink;
